<template>
    <FetchError
        v-if="fetchError"
        :heading="siteContent.entryDoesntExist"
        :text="siteContent.entryDeletedOrBroken"/>
    <main class="entry"
        v-else>
        <HeroSkeleton
            v-if="loading"/>
        <Carousel
            v-else-if="currentArtwork.media.carousel"
            :currentArtwork="currentArtwork"/>

        <Slider
            v-else-if="currentArtwork.media.slider"
            :currentArtwork="currentArtwork"/>

        <section class="details">
            <EntryDetailsSkeleton
                v-if="loading"/>

            <EntryDetails
                v-else
                id="entryDetails"
                :currentEntryId="id"
                :currentArtwork="currentArtwork"
                :editorView="editorView"
                @setEditorView="setEditorView"/>

            <BaseLayout>
                <div class="relatedPostWrapper"
                    v-if="!loading && currentArtwork.extra.relatedPost && !editorView">
                    <BlurCapImage
                        :routerLink="'/post/' + currentPost.slug"
                        :image="currentPost.cover"
                        :badgeLabel="siteContent.relatedPost"
                        badgeType="related">
                            <LeadingPost
                                :post="currentPost"/>
                    </BlurCapImage>
                </div>
                <div class="blurCapFeed"
                    v-if="!loading && !editorView && currentArtwork.flag.visibility">
                    <Comments
                        collection="entryComments"
                        :documentId="id"
                        :notificationDetails="notificationDetails"/>
                </div>
            
                <FeedSkeleton class="feedSkeleton"
                    v-if="loading">
                </FeedSkeleton>
                <RelatedEntries
                    v-else-if="!editorView && currentArtwork.flag.visibility"
                    :currentEntry="currentArtwork"/>
            </BaseLayout>
        </section>
    </main>
</template>

<script>
    import { mapActions, mapState } from 'vuex'

    import HeroSkeleton         from '@/components/entry/skeleton/HeroSkeleton'
    import Carousel             from '@/components/entry/Carousel'
    import Slider               from '@/components/entry/Slider'
    import EntryDetailsSkeleton from '@/components/entry/skeleton/EntryDetailsSkeleton'
    import EntryDetails         from '@/components/entry/EntryDetails'
    import BaseLayout           from '@/components/layout/main/BaseLayout'
    import LeadingPost          from '@/components/blog/main/LeadingPost'
    import Comments             from '@/components/comments/Comments'
    import FeedSkeleton         from '@/components/layout/main/FeedSkeleton'
    import RelatedEntries       from '@/components/entry/RelatedEntries'

    export default {
        name: 'Entry',
        components: {
            HeroSkeleton,
            EntryDetailsSkeleton,
            Carousel,
            Slider,
            EntryDetails,
            BaseLayout,
            LeadingPost,
            Comments,
            FeedSkeleton,
            RelatedEntries,
        },
        props: {
            id: String
        },
        data() {
            return {
                loading:    true,
                editorView: false,
                metaData:   null,
                fetchError: false
            }
        },
        computed: {
            ...mapState('journal',['currentArtwork','previousArtworks','nextArtworks']),
            ...mapState('blog',   ['currentPost']),

            notificationDetails() {
                return {
                    createdBy: this.currentArtwork.creator.artist.id,
                    title:     this.currentArtwork.content.title
                }
            }
        },
        async mounted() {
            this.fetchArtworkDetails()
        },
        methods: {
            ...mapActions('journal',['fetchEntryByID']),
            ...mapActions('blog',   ['fetchPostByID']),

            async fetchArtworkDetails() {
                var result = await this.fetchEntryByID(this.id)

                if(result) {
                    let isVisible = this.currentArtwork.flag.visibility === true
                    
                    if(!isVisible) {
                        let isAdmin = this.permissions.isAdmin
                        let isOwn   = this.auth.id === this.currentArtwork.creator.artist.id

                        if(isAdmin || isOwn) {
                            
                        } else {
                            this.$router.push('/auth')
                        }
                    }

                    if(this.currentArtwork.extra.relatedPost) {
                        try {
                            await this.fetchPostByID(this.currentArtwork.extra.relatedPost)
                        } catch(error) {
                            throw error
                        }
                    }

                    this.metaData = this.currentArtwork
                } else {
                    this.fetchError = true
                }

                this.loading = false
            },
            setEditorView(state) {
                this.editorView = state
            }
        },
        watch: {
            // call again the method if the route changes
            '$route' (to, from) {
                this.loading = true
                this.fetchArtworkDetails()
            }
        },
        metaInfo() {
            if(this.metaData) {
                if(this.preferences.language === 'hu') {
                    return {
                        title: `${this.metaData.content.title.hu + ' | Creatillo'}`,
                        meta: [
                            { vmid: 'description', name: 'description', content: `${this.metaData.content.intro.hu}` }
                        ]
                    }
                } else {
                    return {
                        title: `${this.metaData.content.title.en + ' | Creatillo'}`,
                        meta: [
                            { vmid: 'description', name: 'description', content: `${this.metaData.content.intro.en}` }
                        ]
                    }
                }
                
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../scss/variables';

    .entry {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-bottom: 8rem;
    }

    .details {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        padding: 0 2rem;
    }

    .printsPrWrapper {
        margin-top: 4rem;
        width: 100%;
        max-width: 64rem;
    }

    .relatedPostWrapper, .commentsWrapper {
        width: 100%;
        max-width: 64rem;
        margin: 4rem 0 2rem 0;
        align-self: center;
        position: relative;
        display: flex;
    }

    @media all and (max-width: 800px) {
        .details {
            padding: 0 1rem;
        }
    }

    @media all and (max-width: 560px) {
        .details {
            padding: 0;
        }
    }
</style>